/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why add overage?`)
};

const es_pcr_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué añadir exceso?`)
};

const de_pcr_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum einen Überschuss einplanen?`)
};

const nl_pcr_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom overmaat toevoegen?`)
};

const fr_pcr_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi ajouter une marge ?`)
};

const it_pcr_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché aggiungere un margine?`)
};

const pt_br2_pcr_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que adicionar excedente?`)
};

const pt_pcr_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porquê adicionar excedente?`)
};

const ja_pcr_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜオーバーヘッジを加えるのですか?`)
};

const zh_pcr_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么要加损耗余量？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_faq_q2", locale)
	if (locale === "en") return en_pcr_faq_q2(inputs)
	if (locale === "es") return es_pcr_faq_q2(inputs)
	if (locale === "de") return de_pcr_faq_q2(inputs)
	if (locale === "nl") return nl_pcr_faq_q2(inputs)
	if (locale === "fr") return fr_pcr_faq_q2(inputs)
	if (locale === "it") return it_pcr_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_faq_q2(inputs)
	if (locale === "pt") return pt_pcr_faq_q2(inputs)
	if (locale === "ja") return ja_pcr_faq_q2(inputs)
	return zh_pcr_faq_q2(inputs)
};